import { blue } from "@ant-design/colors";
import MiniInfoCard from "@lib/components/MiniComponents/Dashboard/MiniInfoCard";
import { PiBuildingsBold } from "react-icons/pi";
import { FormattedMessage, useIntl } from "react-intl";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { useCustomerQueries } from "@lib/apiQueries";
import { ROUTES } from "@lib/constants";
import { AppCardProps } from "@lib/components/AppComponents/AppCard";
import { ApiParams } from "@lib/types";

type Props = {
  cardProps?: AppCardProps;
  params?: ApiParams;
};

export default function WhiteLabelMiniCard(props: Props) {
  const { cardProps, params } = props;
  const { messages } = useIntl();
  const navigate = useNavigate();

  const { customersQuery } = useCustomerQueries({
    messages,
    queryKey: ["dashboard-minicard-customers"],
    params: {
      ...params,
    },
  });
  const { data, isLoading } = customersQuery;
  const apiData = data?.data?.data || [];

  const total = apiData.length;
  const newTotal = apiData.filter((d) => {
    const createdAt = dayjs(d.createdAt);
    const startOfMonth = dayjs().startOf("month");
    const endOfMonth = dayjs().endOf("month");

    return createdAt.isBetween(startOfMonth, endOfMonth, null, "[]");
  });

  const handleNavigate = () => {
    navigate(ROUTES.ADMIN.CUSTOMER.LIST);
  };

  return (
    <MiniInfoCard
      loading={isLoading}
      navigate={handleNavigate}
      cardProps={cardProps}
      data={{
        icon: <PiBuildingsBold />,
        color: blue[5],
        desc: (
          <FormattedMessage
            id="common.totalX"
            values={{ x: messages["common.customer"] as string }}
          />
        ),
        title: total,
        rightMenu: {
          key: "new",
          data: {
            data: newTotal.length,
            duration: messages["common.thisMonth"] as string,
          },
        },
      }}
    />
  );
}
